export default __webpack_public_path__ + "static/media/skull-player-light.50dbf07d.svg";